export default __webpack_public_path__ + "static/media/create_question.3a93c6fe.svg";